"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RETURN_TYPE = void 0;
var RETURN_TYPE = {
  nothing: {
    type: 'nothindRefund',
    text: 'Невозвратный тариф'
  },
  partial: {
    type: 'partialRefund',
    text: 'Частичный возврат'
  },
  full: {
    type: 'freeCancellation',
    text: 'Бесплатная отмена'
  }
};
exports.RETURN_TYPE = RETURN_TYPE;